<template>
	<page-content-layout class="calendar" title="Calendar">
		<button-group-view slot="tools" :actions="[
			{
				label: 'Aktive',
				value: 'active'
			},
			{
				label: 'Alle',
				value: 'all'
			},
		]" v-model="workers" />
		<button-group-view slot="tools" :actions="[
			{
				label: 'Postnr',
				value: 'zip'
			},
			{
				label: 'Ankomst',
				value: 'arrival'
			},
			{
				label: 'Omfang',
				value: 'volume'
			},
			{
				label: 'Resume',
				value: 'summary'
			}
		]" v-model="info" />
		<button-group-view slot="tools" :actions="[
			{
				label: 'Detaljeret',
				value: 'detailed'
			},
			{
				label: 'Komprimeret',
				value: 'condensed'
			}
		]" v-model="condensed" />
		<button-view slot="tools" label="..." @click="select" />
		<button-view slot="tools" :label="date" @click.stop="debug($event)" style="display: none;" />
		<div class="layout">
			<div class="search">
				<input type="text" placeholder="Søg efter..." v-model="search" @keyup="searchKeyUp" />
			</div>
			<date-picker-std-view v-model="date" class="date" :status="_status" @browse="updateStatus" :style="{
				opacity: this.search == '' ? 1 : 0,
				transition: 'opacity 250ms'
			}" />
			<div :class="['status', dateStatus]">
				<div :class="{
					left: true,
					active: dateStatus == 'open'
				}" @click="setDateStatus('open')">Åben</div>
				<div :class="{
					active: dateStatus == 'restricted'
				}" @click="setDateStatus('restricted')">Spørg</div>
				<div :class="{
					right: true,
					active: dateStatus == 'closed'
				}" @click="setDateStatus('closed')">Lukket</div>
			</div>
			<div class="booking">
				<div class="label">Tilgængeligt mandskab</div>
				<div class="value">{{ _available }}</div>
			</div>
			<div class="meeting">
				<div class="label">Fremmøde</div>
				<div class="value">{{ _meeting.met }} / {{ _meeting.booked }}</div>
			</div>
			<div class="tabs" :style="{
				opacity: this.search == '' ? 1 : 0,
				transition: 'opacity 250ms'
			}">
				<plethora-tabs-view v-model="tab" :tabs="[
					{
						label: 'Opgaver',
						value: 'tasks',
						badge: {
							visible: false
						}
					},
					{
						label: $store.getters.leadRole.plural,
						value: 'employees'
					},
					{
						label: 'Udeblevet',
						value: 'absent'
					}
					/*{
						label: null,
						value: 'red',
						badge: {
							visible: true,
							label: 30,
							style: {
								background: {
									color: '#f7223f'
								},
								font: {
									color: 'white'
								}
							}
						}
					},
					{
						label: null,
						value: 'yellow',
						badge: {
							visible: true,
							label: 10,
							style: {
								background: {
									color: '#FFCF00'
								},
								font: {
									color: 'white'
								}
							}
						}
					},
					{
						label: null,
						value: 'green',
						badge: {
							visible: true,
							label: 7,
							style: {
								background: {
									color: '#00c017'
								},
								font: {
									color: 'white'
								}
							}
						}:/
					/*{
						label: 'Dagens',
						value: 'scheduled',
						badge: {
							visible: true,
							label: 30,
							style: {
								background: {
									color: '#FFCF00'
								},
								font: {
									color: 'white'
								}
							}
						}
					}/*,
					{
						label: 'Advarsler',
						value: 'warnings',
						bagde: {
							visible: true,
							label: 4,
							style: {
								background: {
									color: '#FFCF00'
								},
								font: {
									color: 'white'
								}
							}
						}
					}*/
				]" />
			</div>
			<perfect-scrollbar class="tasks" name="task" tag="div" :style="{
				gridRow: search == '' ? '7' : '2 / 8',
				transition: 'grid-row 250ms'
			}">
				<transition-group name="task" tag="div">
					<div v-for="task in _tasks" :key="task.id" :class="['task', 'move']" @contextmenu.prevent="taskContext($event, task)" @mouseenter="$store.commit('hover', [task, 'right', 'task'])" @mouseleave="$store.commit('hover', [null, 'right', 'task'])">
						<div class="color" :style="{ backgroundColor: _types.hasOwnProperty(task.type) ? _types[task.type].color : 'yellow' }"></div>
						<div class="name">#{{ task.num }} {{ task.name == '' ? '-' : task.name }}<br><span v-for="(a, b) in task.status.instr" :key="b">{{ a }}</span></div>
						<div class="zip" v-html="getInfo(task)"></div>
						<div style="display: none;" class="arrow">X</div>
						<div v-show="view == 'planning'" class="teams">
							<div class="team" v-for="(team, a) in task.teams" :key="a">
								<div draggable="true" @dragstart="dragStart(task, team)" @dragend="dragEnd()" class="header" :style="{ backgroundColor: colors[team.status] }" @click.stop="bookResource($event, task, team)">
									<div class="title">{{ team.name }}</div>
									<div v-show="team.desc != ''" class="desc">{{ team.desc }}</div>
								</div>
								<div v-for="(req, b) in team.reqs" :key="b" class="reqs">
									<div class="row header">
										<div class="title">{{ _roles.hasOwnProperty(req.role) ? _roles[req.role].label : req.role }}</div>
										<div class="state">{{ req.booked }} / {{ req.qty }}</div>
									</div>
									<div v-for="(prop, c) in req.props" :key="c" class="row">
										<div class="title">{{ _props.hasOwnProperty(c) ? _props[c].label : c }}</div>
										<div class="state">{{ prop.booked }} / {{ prop.qty }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>	
					<div v-for="(e) in _emps" :key="'emp' + e.id" class="employee" draggable="true" @dragstart="empDragStart(e)" @dragend="empDragEnd()">
						<div class="name">
							{{ e.name }}<br>
							<div v-if="!e.reserve" class="status" :style="{ backgroundColor: '#4cb050' }">Arbejdsdag 3</div>
							<div v-if="e.reserve" class="status" :style="{ backgroundColor: e.reserve.color }">{{ e.reserve.note }}</div>
							<div v-if="e.rating != ''" class="rating">{{ e.rating }}</div>
						</div>	
						<div class="bookings" v-if="e.bookings.length > 0">
							<div v-for="b in e.bookings" :key="'booking' + b.id" class="task" @click="unbook({ res_type: 'employee', id: b.id })">#{{ b.task_num }} {{ b.task_name }}<svg-icon icon="close" class="close" @click="unbook({ res_type: 'employee', id: b.id })" /></div>
						</div>	
						<div class="vehicles" v-if="e.bookings.length > 0">
							<div v-for="v in e.vehicles" :key="'vehicles' + v.id" class="vehicle">{{ v.name }}</div>
						</div>	
						<div class="props">
							<div v-for="(p, j) in props2(e)" :key="j">{{ p }}</div>
						</div>
					</div>
					<div v-for="(e) in _absent" :key="'abs' + e.id" class="employee" style="cursor: default;">
						<div class="name">
							{{ e.name }}<br>
							<div v-if="false" class="status" :style="{ backgroundColor: '#f7223f' }">00:00</div>
						</div>
					</div>
					<spinner-view v-if="_tasks == null" />	
				</transition-group>
			</perfect-scrollbar>
			<resource-view @updateBooking="updateBooking" @resource_context="resource_context" @track_context="track_context" @move="move" @pin="pin" :info="info" @context="bookingContext" @filter="setFilter" :filters="_filters" :filter="filter" @unbook="unbook" @copyBookings="copyBookings" class="resources" :bookings="bookings" :hoverRes="hoverRes" :types="_types" :tasks="_allTasks" :resources="_resources_norm" :date="date" :drag="drag" @book="book" @onDragStart="dragStart" @onDragEnd="dragEnd" :reservations="reservations" @hover="hover" :internal="ownership == 'internal'" :external="ownership == 'external'" :condensed="condensed == 'condensed'" :planned="capacity == 'all' || capacity == 'planned'" :free="capacity == 'all' || capacity == 'free'" />
		</div>
		<vehicle-hover-view v-if="$store.state.hoverType == 'vehicle'" :item="$store.state.hover" :align="$store.state.hoverAlign" :roles="vehicleRoles" :events="events" />
	</page-content-layout>
</template>

<script>
	import merge from '../functions/merge'

	import DatePickerStdView from '../views/DatePickerStdView'
	import ResourceView from '../views/ResourceView'
	import ResourcePopupView from '../views/ResourcePopupView'
	import ContextPopupView from '../views/ContextPopupView'
	import HoverView from '../views/HoverView'
	import VehicleHoverView from '../views/VehicleHoverView'

	import TaskModel from '../model/Task'

	import OrderModel from '../model/Order'
	import OrderWindow from '../windows/OrderWindow'
	import WindowClaim from '../windows/ClaimWindow'

	import ContactModel from '../model/Contact'
	import ContactWindow from '../windows/ContactWindow'

	import SurveyTaskModel from '../model/SurveyTask'
	import SurveyTaskWindow from '../windows/SurveyTaskWindow'

	import MoveTaskModel from '../model/MoveTask'
	import MoveTaskWindow from '../windows/MoveTaskWindow'

	import CompoundTaskModel from '../model/CompoundTask'
	import CompoundTaskWindow from '../windows/CompoundTaskWindow'

	import CourierTaskModel from '../model/CourierTask'
	import CourierTaskWindow from '../windows/CourierTaskWindow'

	import BookingWindow from '../windows/BookingWindow'

	import TaskController from '../../components/TaskController'

	import ReservationModel from '../model/Reservation'
	import ReservationWindow from '../windows/ReservationWindow'

	import { bus } from '../../bus'

    export default {
		data: function () {
			return {
				abort: {
					status: null,
					dateStatus: null,
					tasks: null,
					reservations: null,
					bookings: null, 
					resources: null,
					events: null
				},
				booking: {
					employees: {
						needed: 0,
						booked: 0
					}
				},
				meeting: {
					employees: {
						booked: 0,
						met: 0
					}
				},
				dateStatus: null,
				colors: {
					none: '#f7223f',
					semi: '#ffcf00',
					full: '#00c017',
				},
				search: '',
				condensed: 'detailed',
				capacity: 'all',
				ownership: 'all',
				types: [],
				tps: [],
				hoverRes: null,
				date: (new Date()).format('Y-m-d'),
				status: [],
				tasks: [],
				employees: [],
				departments: [],
				instructions: [],
				myTasks: [],
				roles: [],
				props: [],
				reservations: [],
				events: [],
				vehicleRoles: [],
				drag: null,
				tab: 'tasks',
				view: 'planning',
				info: 'zip',
				workers: 'active',
				//filters: [],
				filter: 'vehicle',
				searchTimeout: null,
				types2: [
					{
						name: 'employee',
						label: 'Ansatte',
						roles: [
							{
								name: 'admin',
								label: 'Administration'
							},
							{
								name: 'dev',
								label: 'Udviklere'
							},
							{
								name: 'move',
								label: 'Flyttemænd'
							}
						]
					},
					{
						name: 'vehicle',
						labeL: 'Køretøjer',
						roles: []
					},
					{
						name: 'equipment',
						label: 'Udstyr',
						roles: []
					}
				],
				resources: [],
				bookings: [],
				dragEmp: null
			};
		},
		components: {
			datePickerStdView: DatePickerStdView,
			resourceView: ResourceView,
			hoverView: HoverView,
			vehicleHoverView: VehicleHoverView
		},
		watch: {
			bookings() {
				this.updateBookingState();
			},
			tasks() {
				this.updateBookingState();
			},
			workers() {
				this.update();
			},
			date(n, o) {
				this.tasks = [];
				//this.reservations = [];

				var d = new Date(n);
				this.updateTasks(d.getFullYear(), d.getMonth() + 1, d.getDate());
				this.updateReservations(d.getFullYear(), d.getMonth() + 1, d.getDate());
				this.updateBookings(d.getFullYear(), d.getMonth() + 1, d.getDate());
				this.updateResources(d.getFullYear(), d.getMonth() + 1, d.getDate());
				this.updateEvents(d.getFullYear(), d.getMonth() + 1, d.getDate());
			}
		},
		computed: {
			_available() {
				const employees = this._resources_norm.filter(r => {
					try {
						return r.type == 'employee' && r.bookings.length == 0 && r.reservations.length == 0;
					} catch (err) {
						console.error(err, r);

						return false;
					}
				});

				console.log(employees);

				return employees.length;
			},
			_myTasks() {
				return [];
			},			
			_listTasks() {
				var r = [];

				if (this.search != '') {
					// Show search results
				} else {
					// Show tasks for the day
					for (var i = 0; i < this._tasks.length; ++i) {
						/*if () {

						}*/
					}
				}

				return r;
			},
			_emps() {
				if (this.tab != 'employees') return [];

				var r = [];
				var res;

				for (var i = 0; i < this.resources.length; ++i) {
					res = this.resources[i];

					

					if (res.type == 'employee' && this.$store.getters.leadRole.name in res.roles && res.roles[this.$store.getters.leadRole.name].enabled) {
						// Add reservation
						let rr = this.reservations.reduce((acc, item) => {
							if (item.type == res.type && item.id == res.id) {
								acc.push(item);
							}
							
							return acc;
						}, []);

						if (rr.length > 0) {
							res.reserve = rr[0];
						}

						r.push(res);
					}
				}

				return r.sort(function (a, b) { return a.name < b.name ? -1 : (a.name == b.name ? 0 : 1); });
				
				//return r;
			},
			_resources_norm() {
				var r = [];
				var res;

				for (var i = 0; i < this.resources.length; ++i) {
					res = this.resources[i];

					// Add all reservations
					res.reservations = this.reservations.reduce((acc, item) => {
						if (item.type == res.type && item.id == res.id) {
							acc.push(item);
						}
						
						return acc;
					}, []);

					

					r.push(res);
				}

				return r;
			},
			_filters() {
				var i;
				var role;
				var r = [
					{
						label: 'Køretøjer',
						value: 'vehicle',
						highlight: true,
					},
					null
				];

				if (this.roles && this.roles.vehicle)
				for (i = 0; i < this.roles.vehicle.length; ++i) {
					role = this.roles.vehicle[i];

					r.push({
						label: role.label,
						value: role.name
					});
				}

				r.push(null);

				r.push({
					label: 'Medarbejdere',
					value: 'employee',
					highlight: true,
				});

				r.push(null);

				if (this.roles && this.roles.employee)
				for (i = 0; i < this.roles.employee.length; ++i) {
					role = this.roles.employee[i];

					r.push({
						label: role.label,
						value: role.name
					});
				}

				return r;
			},
			_allTasks() {
				return this.tasks.concat(this.myTasks);
			},
			_absent() {
				if (this.tab != 'absent') return [];

				

				return this._meeting.absent;
			},
			_tasks() {
				if (this.tab != 'tasks') return [];

				var r = [];

				for (var i = 0; i < this.tasks.length; ++i) {
					if (this.info == 'summary') {
						if (this.tasks[i].type == 'move' || this.tasks[i].type == 'handy' || this.tasks[i].type == 'pack' || this.tasks[i].type == 'free') {
							r.push(this.tasks[i]);
						}
					} else {
						r.push(this.tasks[i]);
					}
				}

				return r;
			},
			_status() {
				var r = [];

				var src = this.ownership == 'mine' ? this.status.mine : this.status.all;

				for (var date in src) {
					var s = src[date];

					r.push({
						date: date,
						color: s.red > 0 ? 'red' : (s.yellow > 0 ? 'yellow' : 'green'),
						label: ''
					});
				}

				return r;
			},
			_types() {
				// Source the type -> colour map from the Vuex store (loaded once centrally
				// at app init via the `update` action), not a per-page refetch. The store
				// getter is reactive, so the colour snaps in the moment the types land and
				// the bars never depend on this page's own racy `/tasks/types/` request.
				return this.$store.getters.tasks;
			},
			_departments() {
				var r = {};

				for (var i = 0; i < this.departments.length; ++i) {
					r[this.departments[i].id] = this.departments[i];
				}

				

				return r;
			},
			_instructions() {
				var r = {};

				for (var i = 0; i < this.instructions.length; ++i) {
					r[this.instructions[i].name] = this.instructions[i];
				}

				

				return r;
			},
			_employees() {
				var r = {};

				for (var i = 0; i < this.employees.length; ++i) {
					r[this.employees[i].id] = this.employees[i];
				}

				

				return r;
			},			
			_rolesTypes() {
				var r = [];

				

				for (var name in this.roles) {
					var group = this.roles[name];
					
					for (var j = 0; j < group.length; ++j) {
						var role = group[j];

						r[role.name] = name;
					}
				}

				

				return r;
			},
			_roles() {
				var r = [];

				

				for (var name in this.roles) {
					var group = this.roles[name];
					
					for (var j = 0; j < group.length; ++j) {
						var role = group[j];

						r[role.name] = role;
					}
				}

				

				return r;
			},
			_props() {
				var r = [];

				

				for (var name in this.roles) {
					var group = this.roles[name];
					
					for (var j = 0; j < group.length; ++j) {
						var role = group[j];

						for (var k = 0; k < role.props.length; ++k) {
							var prop = role.props[k];

							r[prop.name] = prop;
						}
					}
				}

				

				return r;
			},
			_resources() {
				var r = [];

				for (var i = 0; i < this.resources.length; ++i) {
					var res = this.resources[i];
					r[res.type + res.id] = res;
				}

				

				return r;
			},
			_typesFull() {
				var r = [];

				for (var i = 0; i < this.tps.length; ++i) {
					r[this.tps[i].name] = this.types[i];

					switch (this.tps[i].name) {
						case 'survey': 		r[this.tps[i].name].window = SurveyTaskWindow;	r[this.tps[i].name].model = SurveyTaskModel; 		break;
						case 'move': 		r[this.tps[i].name].window = MoveTaskWindow; 		r[this.tps[i].name].model = MoveTaskModel;		break;
						//case 'compound': 	r[this.types[i].name].window = CompoundTaskWindow; 	r[this.types[i].name].model = CompoundTaskModel;	break;
						case 'courier': 	r[this.tps[i].name].window = CourierTaskWindow; 	r[this.tps[i].name].model = CourierTaskModel;	break;
					}
				}

				return r;
			},
			_meeting() {
				const t = this.tasks;
				var   e = [];  

				for (var i = 0; i < t.length; ++i) {
					for (var j in t[i].status.bookings) {
						const team = t[i].status.bookings[j];

						for (var k = 0; k < team.employees.length; ++k) {
							e[team.employees[k].id] = team.employees[k];
						}
					}
				}

				

				var ea = [];

				for (i in e) {
					ea.push(e[i]);
				}

				return {
					booked: ea.length,
					met:	ea.reduce((acc, item) => { return acc + (item.met ? 1 : 0); }, 0),
					absent: ea.reduce((acc, item) => { if (!item.met) acc.push(item); return acc; }, [])
				};
			}
		},
		methods: {
			async updateBooking(booking) {
				console.log('update booking', booking);

				const updateTask = confirm('Skal opgavens tider også opdateres?');

				await this.axios.put(`/planning/bookings/${booking.res_type}/${booking.id}`, { ...booking, updateTask });
			},
			props2(e) {
				var r = [];
				var role;
				var roles = this.roles.employee;

				

				for (var i in e.roles) {
					role = e.roles[i];

					if (role.enabled) {
						for (var j in role.props) {
							if (role.props[j]) {
								

								for (var k = 0; k < roles.length; ++k) {
									for (var l = 0; l < roles[k].props.length; ++l) {
										if (roles[k].name == i && roles[k].props[l].name == j) r.push(roles[k].props[l].label);
									}
								}
							}
						}
					}
				}

				return r;
			},
			async open_reservation(id, res) {
				

				const self = this;

				var ent 				= id ? await ReservationModel.read(self.axios, id) : ReservationModel.entity();
				ent.department_id 		= self.$store.state.employee.department_id;

				// New?
				if (id === null) {
					// Add employee
					if (res.type == 'employee') ent.employees = [res.id];

					// Add vehicle
					if (res.type == 'vehicle') ent.vehicles = [res.id];
				}

				self.$store.state.windowStack.push(ReservationWindow, {
					value: ent,
					async submit(entity) {
						if (await ReservationModel.save(self.axios, entity)) {
							self.$store.state.windowStack.pop();
							bus.$emit('clear');
							bus.$emit('update');
						}
					}
				});
			},
			async track_context(event, res, track) {
				

				if (track.reservation_id === null) {
					await this.resource_context(event, res);
					return;
				}

				var self = this;

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event,
					align: 'left',
					actions: [
						{
							label: 'Rediger reservation',
							action: function () {
								self.open_reservation(track.reservation_id, res);
							}
						},
						{
							label: 'Slet reservation',
							action: async function () {
								if (confirm("Er du sikker?")) {
									await ReservationModel.delete(self.axios, track.reservation_id);
									bus.$emit('clear');
									bus.$emit('update');
								}
							}
						},
						null,
						{
							label: 'Opret reservation',
							action: function () {
								self.open_reservation(null, res);
							}
						}
					]
				});
			},
			async resource_context(event, res) {
				

				var self = this;

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event,
					align: 'left',
					actions: [
						{
							label: 'Opret reservation',
							action: function () {
								self.open_reservation(null, res);
							}
						}
					]
				});
			},
			async move(rs) {
				

				var vehicles = [];
				var employees = [];

				for (var i = 0; i < rs.length; ++i) {
					if (rs[i].type == 'vehicle') vehicles.push(rs[i].id); 
					if (rs[i].type == 'employee') employees.push(rs[i].id); 
				}

				if (vehicles.length > 0) await this.axios.put('/fleet/vehicles/order/', vehicles);
				if (employees.length > 0) await this.axios.put('/employees/order/', employees);

				this.updateResources((new Date(this.date)).getFullYear(), (new Date(this.date)).getMonth() + 1, (new Date(this.date)).getDate());
			},
			async pin(res) {
				

				if (res.type == 'employee') {
					await this.axios.put('/employees/' + res.id + '/pin/');
				}

				if (res.type == 'vehicle') {
					await this.axios.put('/fleet/vehicles/' + res.id + '/pin/');
				}

				this.updateResources((new Date(this.date)).getFullYear(), (new Date(this.date)).getMonth() + 1, (new Date(this.date)).getDate());
			},
			select(event) {
				var self = this;

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'right',
					actions: [
						{
							label: 'Send dagens mødetider',
							async action() {
								

								if (!confirm('Er d. ' + self.date + ' den korrekte dato?')) return;

								var cnt = (await self.axios.post('/texts/meetings-time/send/', {
									date: self.date
								})).data;

								if (cnt) {
									alert('Der blev sendt mødetider til ' + cnt + ' medarbejdere');
								} else {
									alert('Der blev ikke fundet nogen mødetider at sende');
								}								
							}
						},
						{
							label: 'Udskriv dagens flytninger',
							action() {
								self.print();
							}
						},
						{
							label: 'Udskriv dagens opgaver',
							action() {
								self.printAll();
							}
						},
					]
				});
			},
			print() {
				window.open(process.env.VUE_APP_API + '/planning/tasks/' + this.date + '/print/?token=' + this.$store.state.auth);
			},
			printAll() {
				window.open(process.env.VUE_APP_API + '/planning/tasks/' + this.date + '/print/all/?token=' + this.$store.state.auth);
			},
			async bookingContext(e, booking, res, task) {
				

				var self = this;


				task.status = (await self.axios.get(`/tasks/${task.id}/meta`)).data.status;


				// Actions
				var actions = [
						{
							label: 'Åben booking',
							action: function () {
								self.taskClick(task, booking);
							}
						},
						{
							label: 'Åben opgave',
							action: function () {
								TaskController.open(self, task.type, task.id);
							}
						},
						{
							label: 'Åben ordre',
							enabled: task.order_id !== null,
							action: async function () {
								var order = {};
				
								var ent = await OrderModel.read(self.axios, task.order_id);

								self.$store.state.windowStack.push(OrderWindow, {
									value: ent, 
									submit: async function (entity, invoice = false, paid = false) {
										if ((order = await OrderModel.save(self.axios, entity, invoice, paid))) {
											//self.$store.state.windowStack.pop();
											//bus.$emit('update');
										}
									}
								});
							}
						},
						{
							label: 'Åben skadesag',
							enabled: task.claim_id !== null,
							action: async function () {
								var ent = (await self.axios.get(`/claims/${task.claim_id}/`)).data;

								self.$store.state.windowStack.push(WindowClaim, {ent: ent, async submit(ent) {
									
									
									await self.axios.put(`/claims/${ent.id}/`, ent);

									bus.$emit('update');
									return false;
								}});
							}
						},
						{
							label: 'Åben kontakt',
							enabled: task.contact_id !== null,
							action: async function () {
								var ent = await ContactModel.read(self.axios, task.contact_id);

								self.$store.state.windowStack.push(ContactWindow, {
									value: ent, 
									submit: async function (entity) {
										if (await ContactModel.save(self.axios, entity)) {
											self.$store.state.windowStack.pop();
											self.update();
										}
									}
								});
							}
						},
						null,
						{
							label: 'Luk opgave',
							enabled: !task.closed,
							async action() {
								await self.axios.put(`/planning/tasks/${task.id}/close/`);
								self.update();
							}
						},
						{
							label: 'Genåben opgave',
							enabled: task.closed,
							async action() {
								await self.axios.put(`/planning/tasks/${task.id}/reopen/`);
								self.update();
							}
						},
						null,
						{
							label: 'Udskriv opgave',
							enabled: true,
							action: async function () {
								window.open(process.env.VUE_APP_API + '/planning/tasks/' + task.id + '/print/?token=' + self.$store.state.auth);
							}
						},
						{
							label: 'Udskriv besigtigelsesformular for privat',
							enabled: task.type == 'survey',
							action: async function () {
								window.open(process.env.VUE_APP_API + '/planning/tasks/' + task.id + '/private/print/?token=' + self.$store.state.auth);
							}
						},
						{
							label: 'Udskriv besigtigelsesformular for erhverv',
							enabled: task.type == 'survey',
							action: async function () {
								window.open(process.env.VUE_APP_API + '/planning/tasks/' + task.id + '/business/print/?token=' + self.$store.state.auth);
							}
						}
					];


				// Add teams

				var i = 0;
				var j = 0;

				actions.push(null);

				for (i in task.status.bookings) {
					actions.push({
						label: 'Tilføj til Hold ' + i,
						action(event) {
							

							self.$store.state.popupController.toggle(ResourcePopupView, {
								anchor: event,
								align: 'left',
								left: 0,
								resources: self.resources.map(function (item) {
									return {
										label: 	item.name,
										id: 	item.id,
										type: 	item.type
									}
								}),
								callback(type, id) {
									

									self.book(task.from.time, task.to.time, task.id, i, type, id);
								}
							});
						}
					});

					// Remove employee
					for (j = 0; j < task.status.bookings[i].employees.length; ++j) {
						actions.push({
							label: 'Fjern ' + task.status.bookings[i].employees[j].name,
							action: function () {
								var booking_id = task.status.bookings[i].employees[j].booking_id;

								return function () {
									//

									self.unbook({
										res_type: 'employee',
										id: booking_id
									}, res);
								};
							}()
						});
					}

					// Add vehicles
					for (j = 0; j < task.status.bookings[i].vehicles.length; ++j) {
						var veh = task.status.bookings[i].vehicles[j];

						actions.push({
							label: 'Vælg chauffør for ' + (veh.driver ? veh.name + ' (' + veh.driver + ')' : veh.name),
							async action(event) {
								self.$store.state.popupController.toggle(ResourcePopupView, {
									anchor: event,
									align: 'left',
									left: 0,
									resources: self.resources.filter(function (item) {
										return item.type == 'employee';
									}).map(function (item) {
										return {
											label: 	item.name,
											id: 	item.id,
											type: 	item.type
										}
									}),
									async callback(type, id) {
										

										var emp = task.status.bookings[i].employees.find(function (el) {
											return el.id == id;
										});

										

										if (typeof emp == 'undefined') {
											var { data } = await self.book(task.from.time, task.to.time, task.id, i, type, id, false);
										} else {
											var data = {
												id: emp.booking_id
											};
										}

										await self.axios.put('/planning/bookings/vehicle/' + veh.booking_id + '/driver/', {
											employee_booking_id: data.id
										});

										self.update();
									}
								});
							}
						});
					}
				}

				//if (vehs.length > 0) {
				//	actions.push(null);

					/*

	label: 'Vælg chauffør for ' + (vehs[i].driver ? vehs[i].name + ' (' + vehs[i].driver + ')' : vehs[i].name),

					await self.axios.put('/planning/bookings/vehicle/' + v.booking_id + '/driver/', {
															employee_booking_id: e.booking_id
														});
					*/

				//}




				actions.push(null);
				actions.push({
					label: 'Slet booking',
					action: function () {
						self.unbook(booking, res);
					}
				});



				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: e,
					align: 'left',
					actions: actions
				});
			},
			taskContext(e, task) {
				//

				var self = this;

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: e,
					align: 'left',
					actions: [
						{
							label: 'Åben opgave',
							action: function () {
								TaskController.open(self, task.type, task.id);
							}
						},
						{
							label: 'Åben ordre',
							enabled: task.order_id !== null,
							action: async function () {
								var ent = await OrderModel.read(self.axios, task.order_id);

								self.$store.state.windowStack.push(OrderWindow, {
									value: ent, 
									submit: async function (entity) {
										if (await OrderModel.save(self.axios, entity)) {
											self.$store.state.windowStack.pop();
											self.update();
										}
									}
								});
							}
						},
						{
							label: 'Åben kontakt',
							enabled: task.contact_id !== null,
							action: async function () {
								var ent = await ContactModel.read(self.axios, task.contact_id);

								self.$store.state.windowStack.push(ContactWindow, {
									value: ent, 
									submit: async function (entity) {
										if (await ContactModel.save(self.axios, entity)) {
											self.$store.state.windowStack.pop();
											self.update();
										}
									}
								});
							}
						},
						null,
						{
							label: 'Udskriv opgave',
							enabled: true,
							action: async function () {
								window.open(process.env.VUE_APP_API + '/planning/tasks/' + task.id + '/print/?token=' + self.$store.state.auth);
							}
						},
						{
							label: 'Udskriv besigtigelsesformular for privat',
							enabled: task.type == 'survey',
							action: async function () {
								window.open(process.env.VUE_APP_API + '/planning/tasks/' + task.id + '/private/print/?token=' + self.$store.state.auth);
							}
						},
						{
							label: 'Udskriv besigtigelsesformular for erhverv',
							enabled: task.type == 'survey',
							action: async function () {
								window.open(process.env.VUE_APP_API + '/planning/tasks/' + task.id + '/business/print/?token=' + self.$store.state.auth);
							}
						},
						null,
						{
							label: 'Slet alle bookinger',
							action: async function () {
								self.axios
									.delete('/planning/bookings/task/' + task.id + '/')
									.then(function (r) {
										self.update();
									});
							}
						},
						{
							label: 'Slet opgave',
							action: async function () {
								//self.unbook(booking, res);
								await TaskModel.delete(self.axios, task.id);
								self.update();
							}
						}
					]
				});
			},
			getInfo(task) {
				if (this.info == 'zip') {
					return this.zipCodes(task.route[0]);
				}

				if (this.info == 'arrival') {
					return this.$options.filters.timestamp(task.from.time);
				}

				if (this.info == 'volume') {
					return task.secondary;
				}
			},
			searchKeyUp() {
				
				
				if (this.searchTimeout !== null) {
					clearTimeout(this.searchTimeout);
				}
			},
			doSearch() {
				
			},
			taskClick(task, booking) {
				
				//this.open(task.type, task.id);

				var self 	= this;
				var from 	= new Date(booking.from);
				var to 		= new Date(booking.to);

				this.$store.state.windowStack.push(BookingWindow, {
					from_date: 	from.format('Y-m-d'),
					from_time: 	from.format('H:i'),
					to_date: 	to.format('Y-m-d'),
					to_time: 	to.format('H:i'),
					async submit(from, to) {
						self.axios
							.delete('/planning/bookings/' + booking.res_type + '/' + booking.id + '/')
							.then(function (r) {
								self.axios
									.post('/planning/bookings/', {
										task_id: booking.task_id,
										res_id: booking.res_id,
										res_type: booking.res_type,
										team_id: booking.team_id,
										from: from,
										to: to
									})
									.then(function (r) {
										self.$store.state.windowStack.pop();
										self.update();
									});
							});
					}
				});
			},
			async open(type, id) {
				var self 	= this;
				var window 	= this._typesFull[type].window;
				var model 	= this._typesFull[type].model;

				

				var ent = id ? await model.read(this.axios, id) : model.entity();
				ent.type = type;

				this.$store.state.windowStack.push(window, {
					value: ent,
					async submit(entity) {
						if (await model.save(self.axios, entity)) {
							self.$store.state.windowStack.pop();
							self.update();
						}
					}
				});
			},
			hover(res) {
				this.hoverRes = res;
			},
			zipCodes(s) {
				if (s.from.zip == s.to.zip || s.to.zip == '') {
					return s.from.zip;
				} else {
					return s.from.zip + ' til ' + s.to.zip;
				}
			},
			debug(event) {
				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					actions: [
						{
							label: 'Op',
							action: function () {
								
							}
						},
						{
							label: 'Ned',
							action: function () {
								
							}
						},
						{
							label: 'Ingen'
						}
					]
				});
			},
			updateStatus(year, month) {
				var self = this;

				//self.status = [];

				// Status
				this.axios
					.get('/planning/status/' + year + '/' + month + '/', {
						signal: this.prepareUpdate('status')
					})
					.then(function (r) {
						self.status = r.data;

						// Reset abort controller
						self.endUpdate('status');
					}, (err) => {
						// Nothing
					});
			},
			getNeededEmployees() {
				return 0;
			},
			getBookedEmployees() {
				return 0;
			},
			updateBookingState() {
				// Update counters
				this.booking.employees.booked = 0;
				this.booking.employees.needed = 0;

				// Recalculate here
			},
			updateTasks(year, month, day) {
				var self = this;

				// Status
				(async  () => {
					const signal = self.prepareUpdate('tasks');

					const tasks = (await self.axios.get(`/planning/tasks/${year}/${month}/${day}?workers=${this.workers}`, {
						signal: signal
					})).data;

					// Read needed meta async
					let pStatus = [];

					for (const task of tasks) {
						if (task.status) {
							pStatus.push(new Promise((resolve) => {
								resolve({});
							}));
						} else {
							pStatus.push(self.axios.get(`/tasks/${task.id}/status`), {
								signal: signal
							});
						}
					}

					const rStatus = await Promise.all(pStatus);

					for (const i in tasks) {
						tasks[i].status = rStatus[i];
					}

					self.tasks = tasks;

					// Update counters
					self.booking.employees.booked = 0;
					self.booking.employees.needed = 0;

					for (var i = 0; i < self.tasks.length; ++i) {
						for (var j in self.tasks[i].status.bookings) {
							self.booking.employees.booked += self.tasks[i].status.bookings[j].employees.length;
						}

						self.booking.employees.needed += self.tasks[i].status.totals ? self.tasks[i].status.totals.employees : 0;
					}

					// Reset abort controller
					self.endUpdate('tasks');
				})();				

				this.updateDateStatus();
			},
			updateDateStatus() {
				var self = this;

				// And date status
				this.axios
					.get('/planning/' + this.date + '/status/', {
						signal: this.prepareUpdate('dateStatus')
					})
					.then(function (r) {
						
						self.dateStatus = r.data;

						// Reset abort controller
						self.endUpdate('dateStatus');
					});
			},
			updateMyTasks() {
				var self = this;

				

				// Status
				/*this.axios
					.get('/me/tasks/')
					.then(function (r) {
						
						self.myTasks = r.data;
					});*/
			},
			updateResources(year, month, day) {
				var self = this;

				// Status
				this.axios
					.get('/planning/resources/' + year + '/' + month + '/' + day + '/' + '?workers=' + this.workers, {
						signal: this.prepareUpdate('resources')
					})
					.then(function (r) {
						
						self.resources = r.data;

						// Reset
						self.endUpdate('resources');
					});
			},
			updateReservations(year, month, day) {
				var self = this;

				this.axios
					.get('/planning/reservations/?date=' + (new Date(year, month - 1, day)).format('Y-m-d') + '&workers=' + this.workers, {
						signal: this.prepareUpdate('reservations')
					})
					.then(function (r) {
						
						self.reservations = r.data._items;

						// Reset
						self.endUpdate('reservations');
					});
			},
			updateBookings(year, month, day) {
				var self = this;

				this.axios
					.get('/planning/bookings/' + year + '/' + month + '/' + day + '/' + "?workers=" + this.workers, {
						signal: this.prepareUpdate('bookings')
					})
					.then(function (r) {
						//
						self.bookings = r.data._items;

						

						// Reset abort controller
						self.endUpdate('bookings');
					});
			},
			updateEvents(year, month, day) {
				var self = this;

				self.events = [];

				this.axios
					.get('/fleet/vehicles/events/' + year + '-' + month + '-' + day + '/?workers=' + this.workers, {
						signal: this.prepareUpdate('events')
					})
					.then(function (r) {
						//
						self.events = r.data;

						//

						// Reset
						self.endUpdate('events');
					});

				
			},
			update() {
				this.axios.put('/activity/planning/');

				this.updateStatus((new Date(this.date)).getFullYear(), (new Date(this.date)).getMonth() + 1);
				this.updateTasks((new Date(this.date)).getFullYear(), (new Date(this.date)).getMonth() + 1, (new Date(this.date)).getDate());
				this.updateResources((new Date(this.date)).getFullYear(), (new Date(this.date)).getMonth() + 1, (new Date(this.date)).getDate());
				this.updateReservations((new Date(this.date)).getFullYear(), (new Date(this.date)).getMonth() + 1, (new Date(this.date)).getDate());
				this.updateBookings((new Date(this.date)).getFullYear(), (new Date(this.date)).getMonth() + 1, (new Date(this.date)).getDate());
				this.updateEvents((new Date(this.date)).getFullYear(), (new Date(this.date)).getMonth() + 1, (new Date(this.date)).getDate());
				this.updateMyTasks();
			},
			prepareUpdate(name) {
				if (this.abort[name]) {
					this.abort[name].abort();
				}

				const ctrl = new AbortController();
				this.abort[name] = ctrl;
				
				return ctrl.signal;
			},
			endUpdate(name) {
				this.abort[name] = null;
			},
			dragStart(task, team, booking) {
				this.drag = {
					type:		'task',
					task: 		task,
					team: 		team,
					booking: 	booking
				};

				
			},
			dragEnd() {
				this.drag = null;
				this.hoverRes = null;
				
			},
			empDragStart(emp) {
				this.drag = {
					type:		'employee',
					emp:		emp
				};

				
			},
			empDragEnd() {
				this.drag = null;
				this.hoverRes = null;
				
			},
			async copyBookings(emp, bookings) {
				

				if (bookings.length == 0) {
					alert('Der er ingen bookinger på denne resurse');
					return;
				}

				await this.axios.post(`/employees/${emp.id}/bookings/`, bookings);
				this.update();
			},
			async book(from, to, taskId, teamId, resType, resId, booking, update = true) {
				// Are you allowed? (only for vehicles)
				if (resType == 'vehicle' && this.dateStatus != 'open' && !this.$store.state.employee.privileges.day_status) {
					alert('Du har ikke lov til at booke på begrænsede eller lukkede dage');
					return;
				}

				// Comfirn limited days
				if (resType == 'vehicle' && this.dateStatus != 'open' && !confirm('Dagen er begrænset eller lukket, er du sikker på at du vil booke?')) {
					return;
				}

				var self = this;
				var res = null;

				// Test
				const test = (await self.axios.post('/planning/test/', { res_type: resType, res_id: resId, from: from, to: to })).data;
				if (test.status == 'error' && !confirm(test.msg)) return;					

				if (booking) {
					await this.axios.delete('/planning/bookings/' + booking.res_type + '/' + booking.id + '/');				

					res = await this.axios.post('/planning/bookings/', {
						task_id: taskId,
						res_id: resId,
						res_type: resType,
						team_id: teamId,
						from: from,
						to: to
					});

					//self.update();
					/*this.axios
						.delete('/planning/bookings/' + booking.res_type + '/' + booking.id + '/')
						.then(function (r) {
							self.axios
								.post('/planning/bookings/', {
									task_id: taskId,
									res_id: resId,
									res_type: resType,
									team_id: teamId,
									from: from,
									to: to
								})
								.then(function (r) {
									self.update();
								});
						});*/
				} else {
					res = await this.axios.post('/planning/bookings/', {
						task_id: taskId,
						res_id: resId,
						res_type: resType,
						team_id: teamId,
						from: from,
						to: to
					});

					//self.update();
				}

				if (update) {
					self.update();
				}

				return res;

				/*if (drag.requirement.id === null && res.id === null) return;

				if (res.id === null) {
					if (!confirm('Sikker?')) return;
				}

				
				var self = this;

				this.axios
					.put('/planning/bookings/', {
						task_id: drag.task.id,
						stop_idx: drag.stopIdx,
						req_idx: drag.reqIdx,
						res_id: res.id,
						team_idx: drag.teamIdx
					})
					.then(function (r) {
						self.update();
					});*/
			},
			unbook(booking, res) {
				var self = this;

				if (!confirm('Er du sikker?')) {
					return;
				}

				//

				this.axios
					.delete('/planning/bookings/' + booking.res_type + '/' + booking.id + '/')
					.then(function (r) {
						self.update();
					});
			},
			bookResource(event, task, team) {
				console.log('booking resource');
				
				var self = this;

				this.$store.state.popupController.toggle(ResourcePopupView, {
					anchor: event.currentTarget,
					align: 'left',
					left: 0,
					resources: this.resources.filter((item) => {
						return item.active;
					}).map(function (item) {
						return {
							label: 	item.name,
							id: 	item.id,
							type: 	item.type
						}
					}),
					callback(type, id) {
						

						self.book(task.from.time, task.to.time, task.id, team.id, type, id);
					}
				});
			},
			setFilter(name) {
				this.filter = name;
			},
			async setDateStatus(status) {
				// Are you allowed?
				if (!this.$store.state.employee.privileges.day_status) {
					alert('Du har ikke lov til at skifte dagsstatus');
					return;
				}

				await this.axios.put('/planning/' + this.date + '/status/', {
					status: status
				});

				this.updateDateStatus();
			}
		},
		mounted() {
			this.update();

			var self = this;

			this.axios
				.get('/tasks/types/')
				.then(function (r) {
					self.types = r.data._items;
				});

			// Get roles
			this.axios
				.get('/planning/roles/')
				.then(function (r) {
					

					self.roles = r.data;
					
				});

			this.axios
				.get('/tasks/types/')
				.then(function (r) {
					self.tps = r.data._items;
				});

			this.axios
				.get('/employees/?workers=' + this.workers)
				.then(function (r) {
					self.employees = r.data._items;
				});

			this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
				});

			this.axios
				.get('/tasks/instructions/')
				.then(function (r) {
					self.instructions = r.data._items;

					
				});

			this.axios
				.get('/fleet/vehicles/roles/')
				.then(function (r) {
					self.vehicleRoles = r.data._items;

					//
				});

			bus.$on('update', function () {
				self.update();
			});

			bus.$on('clear', function () {
				self.tasks = [];
				self.resources = [];
				self.bookings = [];
				self.status = [];
				self.reservations = [];
				self.events = [];
			});
		},
		beforeRouteLeave(to, from, next) {
			bus.$off('update');
			bus.$off('clear');

			next();
		}
    }
</script>

<style lang="scss" scoped>
	.layout {
		background-color: #F0F0F0;
		width: 100%;
		height: 100%;
		display: grid;
		grid-template-columns: 320px 1fr;
		grid-template-rows: 60px auto auto auto auto auto 1fr;

		& > .tasks {
			padding: 20px;

			& > * > .task {
				box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);

				background-color: white;
				overflow: hidden;
				margin-bottom: 20px;
				border-radius: 5px;
				display: grid;
				grid-template-columns: [left] 5px [after-color] 135px [after-zip] 100px [after-info] 40px [right];
				grid-template-rows: [top] auto [after-name] auto [after-zip] auto [bottom];

				&:last-child {
					margin-bottom: 0;
				}

				& > .color {
					grid-column: left / after-color;
					grid-row: top / bottom;
				}

				& > .name {
					grid-column: after-color / after-info;
					grid-row: top / after-name;
					padding: 5px;
					font-weight: bold;

					& > span {
						background-color: #f7223f;
						color: white;
						font-size: 12px;
						margin: 5px 5px 0 0;
						padding: 3px 5px 3px 5px;
						font-weight: normal;
					}
				}

				& > .zip {
					grid-column: after-color / after-info;
					grid-row: after-name / after-zip;
					padding: 0 5px 5px 5px;
				}

				& > .secondary {
					grid-column: after-zip / right;
					grid-row: after-name / after-zip;
					padding: 0 5px 5px 5px;
					text-align: right;
				}

				& > .arrow {
					grid-column: after-info / right;
					grid-row: top / after-zip;

				}

				& > .teams {
					grid-column: after-color / right;
					grid-row: after-zip / bottom;

					& > .team {
						border-top: 1px solid #f0f0f0;
						padding: 5px;

						& > .header {
							padding: 5px;
							border-radius: 3px;
							cursor: grab;
							color: white;

							& > .title {
								font-weight: bold;
							}

							& > .desc {
								width: 100%;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
								margin-top: 5px;
								font-style: italic;
							}
						}

						& > .reqs {
							& > .row {
								display: grid;
								grid-template-columns: 215px 50px;
								margin-top: 5px;

								& > .title, & > .state {
									font-size: 14px;
								}

								& > .title {
									overflow: hidden;
									text-overflow: ellipsis;
									white-space: nowrap;
								}

								& > .state {
									text-align: right;
								}

								&.header {
									margin-top: 10px;

									&::first-child {
										margin-top: 0px;
									}

									& > .title, & > .state {
										font-size: 16px;
									}
								}
							}
						}
					}
				}
			}
		}
	}

	.search {
		grid-column: 1;
		grid-row: 1;
		background-color: #f0f0f0;
		border-bottom: 4px solid #e2e2e2;

		& > input {
			height: 100%;
			width: 100%;
			padding-left: 20px;
		}
	}

	.date {
		grid-column: 1;
		grid-row: 2;
		background-color: #f0f0f0;
		padding: 30px 30px 20px 30px;
	}

	.status {
		grid-column: 1;
		grid-row: 3;
		background-color: #f0f0f0;
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		padding: 0 30px 20px 30px;

		& > div {
			text-align: center;
			border: 1px solid black;
			border-right: none;
			padding: 5px 0 5px 0;
			font-size: 12px;
			cursor: pointer;
			color: #979797;

			&.left {
				border-radius: 3px 0 0 3px;
			}

			&.right {
				border-right: 1px solid black;
				border-radius: 0 3px 3px 0;
			}
		}

		&.open {
			& > div {
				border-color: #00c017;

				&.active {
					color: white;
					background-color: #00c017;
				}
			}
		}

		&.restricted {
			& > div {
				border-color: #ffcf00;

				&.active {
					color: white;
					background-color: #ffcf00;
				}
			}
		}

		&.closed {
			& > div {
				border-color: #f7223f;

				&.active {
					color: white;
					background-color: #f7223f;
				}
			}
		}
	}

	.booking {
		grid-column: 1;
		grid-row: 4;
		background-color: #f0f0f0;
		display: grid;
		grid-template-columns: 2fr 1fr;
		padding-bottom: 20px;

		& > div {
			font-size: 14px;
		}

		& > .label {
			padding-left: 30px;
		}

		& > .value {
			text-align: right;
			padding-right: 30px;
		}
	}

	.meeting {
		grid-column: 1;
		grid-row: 5;
		background-color: #f0f0f0;
		display: grid;
		grid-template-columns: 2fr 1fr;
		padding-bottom: 20px;

		& > div {
			font-size: 14px;
		}

		& > .label {
			padding-left: 30px;
		}

		& > .value {
			text-align: right;
			padding-right: 30px;
		}
	}

	.tabs {
		grid-column: 1;
		grid-row: 6;
		background-color: #f0f0f0;
		padding-left: 30px;
		border-bottom: 1px solid #cecece;
		height: 54px;
	}

	.tasks {
		grid-column: 1;
		grid-row: 7;
		background-color: #f0f0f0;		

		& > * > .employee {
			display: block;
			background-color: white;
			margin-bottom: 20px;
			border-radius: 5px;
			overflow: hidden;
			cursor: grab;

			-webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
			box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);

			& > .name {
				font-weight: bold;
				padding: 5px;
				position: relative;

				& > .status {
					display: inline-block;
					border-radius: 3px;
					color: white;
					font-size: 12px;
					padding: 3px 5px 3px 5px;
					margin-top: 5px;
					font-weight: normal;
				}

				& > .rating {
					position: absolute;
					top: 5px;
					right: 5px;
					background-color: rgb(153, 153, 153);
					color: white;
					width: 20px;
					line-height: 20px;
					text-align: center;
					border-radius: 3px;
				}
			}

			& > .bookings, & > .vehicles {
				padding: 5px;
				border-top: 1px solid #F0F0F0;

				& > div {
					font-size: 12px;
					line-height: 20px;

					cursor: pointer;

					& > .close {
						display: inline-block;
						width: 12px;
						height: 12px;
						float: right;
						margin: 3px 2px 0 0;

						cursor: pointer;
					}
				}
			}

			& > .props {
				border-top: 1px solid #F0F0F0;
				padding: 5px;

				& > div {
					font-size: 12px;
				}
			}
		}
	}

	.resources {
		grid-column: 2 / 3;
		grid-row: 1 / 8;
		border-left: 1px solid #cecece;
	}

	.task-enter-active, .task-leave-active {
		transition: opacity .25s;
	}

	.task-enter, .task-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}
</style>